import styles from './text-inline-image-section-wrapper.module.css'
import {
  TextInlineImageProps,
  TextInlineImageSection,
} from '@cinch-nx/landing-ui-shared'

export interface TextInlineImageSectionProps {
  textInlineImages: TextInlineImageProps[]
}

export const TextInlineImageSectionWrapper = ({
  textInlineImages,
}: TextInlineImageSectionProps) => (
  <div className={styles.container} aria-describedby="hero-heading">
    <TextInlineImageSection textInlineImages={textInlineImages} />
  </div>
)
